import { apiRequest } from './apiClient';

export const createMarketBid = (payload) =>
  apiRequest('/market/bids', {
    method: 'POST',
    auth: true,
    body: payload,
  });

export const getSubmittedBids = () =>
  apiRequest('/market/bids', {
    auth: true,
  });

export const getReceivedBids = () =>
  apiRequest('/market/bids/received', {
    auth: true,
  });

export const acceptReceivedBid = (bidId, payload = {}) =>
  apiRequest(`/market/bids/${bidId}/accept`, {
    method: 'POST',
    auth: true,
    body: payload,
  });

export const rejectReceivedBid = (bidId) =>
  apiRequest(`/market/bids/${bidId}/reject`, {
    method: 'POST',
    auth: true,
  });
